import React from "react";
import { Link } from "react-router-dom";
import { listPublishedInsights } from "../../services/insights-admin-service";

const featuredInsights = () => {
  const published = listPublishedInsights();
  const featured = published
    .filter((post) => post.featured)
    .sort((a, b) => {
      const rankA = Number(a.featuredRank || 999);
      const rankB = Number(b.featuredRank || 999);
      if (rankA !== rankB) return rankA - rankB;
      return new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime();
    })
    .slice(0, 3);
  return featured.length >= 3 ? featured : published.slice(0, 3);
};

const NewInsights = () => (
  <section className="insights-v2" aria-labelledby="insights-heading" id="insights">
    <div className="container">
      <p className="section-eyebrow">Insights &amp; Perspectives</p>
      <h2 id="insights-heading" className="section-title">
        Research-led thinking from the field.
      </h2>
      <p className="section-sub">
        Views on enterprise software engineering, AI enablement and legacy modernization from Avani Cimcon's delivery teams.
      </p>

      <div className="row">
        {featuredInsights().map((post) => (
          <div key={post.slug} className="col-lg-4 mb-4">
            <article className="insight-card">
              <div className="insight-card-body">
                <span className="insight-card-tag">{post.category}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="insight-card-link">
                  Read more →
                </Link>
              </div>
            </article>
          </div>
        ))}
      </div>

      <div className="text-center mt-2">
        <Link to="/resources/insights" className="hero-v2-btn-primary" style={{ display: "inline-block" }}>
          View All Insights →
        </Link>
      </div>
    </div>
  </section>
);

export default NewInsights;
